/**
 * RatingRegisterContainer
 * --
 */
import React from 'react';
import RatingRegisterPresenter from './RatingRegisterPresenter';

const RatingRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <RatingRegisterPresenter />
    </>
  );
};

export default RatingRegisterContainer;
